module.exports = __webpack_public_path__ + "static/media/exploding-head-svgrepo-com.47406605.svg";